import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import router from './App';
import { ToastProvider } from './components/Toast';
import './styles/fonts.css';
import './styles/tokens.css';
import './styles/global.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* Casting- und Vokabular-Provider sitzen NICHT mehr hier, sondern in
        src/pages/admin/AdminRoot.tsx — sie werden ausschliesslich vom
        Admin-Zweig gebraucht und gehoeren damit in dessen lazy Chunk. */}
    <ToastProvider>
      <RouterProvider router={router} />
    </ToastProvider>
  </StrictMode>
);
